import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useLang, translations } from "../i18n";
import { WaitlistForm } from "./WaitlistForm";

export function CtaSection() {
  const { lang } = useLang();
  const t = translations.cta;
  const ref = useScrollReveal(0);

  return (
    <section
      id="waitlist"
      className="bg-[var(--background)] py-20 md:py-28 lg:py-32 px-6 md:px-12 lg:px-20"
    >
      <div ref={ref} className="max-w-2xl mx-auto">
        <div className="reveal mb-4 text-center">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-[var(--primary)] px-3 py-1.5 bg-[var(--primary)]/8 border border-[var(--primary)]/15 rounded-full">
            {t.badge[lang]}
          </span>
        </div>
        <h2 className="reveal text-3xl md:text-[40px] font-extrabold tracking-tight text-[var(--foreground)] leading-[1.15] mb-3 text-center">
          {t.heading[lang]}
        </h2>
        <p className="reveal text-[15px] text-[var(--muted-foreground)] mb-10 text-center max-w-lg mx-auto leading-relaxed">
          {t.description[lang]}
        </p>
        <div className="reveal">
          <WaitlistForm variant="light" />
        </div>
      </div>
    </section>
  );
}
